import React, { Component } from "react";

import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { brandRoute } from "../../../helpers/restaurantSlugDetector";
import PWAInstallation from "../PWAInstallation";

class Footer extends Component {
	state = {
		active_home: false,
		active_nearme: false,
		active_explore: false,
		active_cart: false,
		active_account: false,
		active_alerts: false,
		pickup_drop: false,
		unread_alerts_count: null,
	};

	componentDidMount() {
		this.syncActiveState(this.props);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.active_home !== this.props.active_home || prevProps.active_explore !== this.props.active_explore ||
			prevProps.active_cart !== this.props.active_cart || prevProps.active_account !== this.props.active_account) {
			this.syncActiveState(this.props);
		}
	}

	syncActiveState = (props) => {
		this.setState({
			active_nearme: props.active_nearme === true,
			active_home: props.active_home === true,
			active_explore: props.active_explore === true,
			active_cart: props.active_cart === true,
			active_account: props.active_account === true,
			active_alerts: props.active_alerts === true,
			pickup_drop: props.pickup_drop === true,
		});
	}

	render() {
		const { cartTotal, alertUnreadTotal } = this.props;
		
		// Get dynamic WhatsApp number from store phone number list
		let whatsappNumber = "";
		const phoneNumberListStr = localStorage.getItem("storePhoneNumberList");
		
		if (phoneNumberListStr) {
			try {
				const phoneEntries = JSON.parse(phoneNumberListStr);
				if (Array.isArray(phoneEntries) && phoneEntries.length > 0) {
					// Prefer "Billing" or "Manager" role, otherwise use first
					const preferredPhone = phoneEntries.find(p => 
						p.role && (p.role.toLowerCase().includes('billing') || p.role.toLowerCase().includes('manager'))
					) || phoneEntries[0];
					
					if (preferredPhone && preferredPhone.phone) {
						whatsappNumber = preferredPhone.phone.replace(/\D/g, "");
					}
				}
			} catch (e) {
				console.error("Error parsing storePhoneNumberList:", e);
			}
		}
		
		// Fallback to stored WhatsApp/support number
		if (!whatsappNumber || whatsappNumber.length < 10) {
			whatsappNumber = (localStorage.getItem("whatsappContactNumber") || localStorage.getItem("supportContactNumber") || "").replace(/\D/g, "");
		}
		
		// Final fallback to user phone
		if (!whatsappNumber || whatsappNumber.length < 10) {
			const userPhone = (this.props.user && this.props.user.data && this.props.user.data.phone ? this.props.user.data.phone : "").replace(/\D/g, "");
			whatsappNumber = userPhone;
		}
		
		const showWhatsApp = false; //fixme: enable this after
		// const showWhatsApp = localStorage.getItem("showWhatsappContact") !== "false" &&
		// 	this.state.active_home &&
		// 	whatsappNumber.length >= 10;

		return (
			<React.Fragment>
				{localStorage.getItem("showPwaInstallPromptFooter") === "true" && <PWAInstallation type={"footer"} />}
				{/* WhatsApp floating icon - above bottom bar, right side (only on Home) */}
				{showWhatsApp && (
					<a
						href={`https://wa.me/${whatsappNumber}`}
						target="_blank"
						rel="noopener noreferrer"
						aria-label="WhatsApp"
						style={{
							position: "fixed",
							bottom: "85px",
							right: "16px",
							width: "48px",
							height: "48px",
							borderRadius: "50%",
							backgroundColor: "#25D366",
							color: "#fff",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
							zIndex: 999,
							textDecoration: "none",
						}}
					>
						<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
							<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
						</svg>
					</a>
				)}

				<div className="d-flex justify-content-center">
					<div
						className={`content pt-5 py-5 font-size-xs clearfix ${
							localStorage.getItem("footerStyleType") === "FLOAT" ? "footer-float" : "footer-fixed"
						}`}
					>
						<NavLink to={brandRoute("/")} className="col footer-links px-2 py-1">
							<i className={this.state.active_home ? "ri-home-8-fill footer-active-links footer-icon" : "ri-home-8-line footer-icon"} /> <br />
							<span className={this.state.active_home ? "active-footer-tab" : ""}>
								{this.state.active_home
									? "Home"
									: "Home"}
							</span>
						</NavLink>
						{/* <NavLink to={brandRoute("/fresh-meat")} className="col footer-links px-2 py-1">
							<i className={this.state.active_nearme ? "ri-store-2-fill footer-active-links footer-icon" : "ri-store-2-line footer-icon"} /> <br />
							<span className={this.state.active_nearme ? "active-footer-tab" : ""}>
								{this.state.active_nearme ? (
									localStorage.getItem("footerNearme")
								) : (
									<span> {localStorage.getItem("footerNearme")}</span>
								)}
							</span>
						</NavLink> */}
						{/* <NavLink to="/alerts" className="col footer-links px-2 py-1">
							<span
								className="cart-quantity-badge"
								style={{ backgroundColor: localStorage.getItem("storeColor") }}
							>
								{alertUnreadTotal}
							</span>
							<i className="si si-bell footer-icon" /> <br />
							<span className={this.state.active_alerts ? "active-footer-tab" : ""}>
								{this.state.active_alerts ? (
									localStorage.getItem("footerAlerts")
								) : (
									<span> {localStorage.getItem("footerAlerts")}</span>
								)}
							</span>
						</NavLink> */}
						<NavLink to={brandRoute("/explore")} className="col footer-links px-2 py-1">
							<i className={this.state.active_explore ? "ri-search-fill footer-active-links footer-icon" : "ri-search-line footer-icon"} /> <br />
							<span className={this.state.active_explore ? "active-footer-tab" : ""}>
								{this.state.active_explore
									? localStorage.getItem("footerExplore")
									: localStorage.getItem("footerExplore")}
							</span>
						</NavLink>
						{/* {localStorage.getItem("enablePickupDrop") === "true" ? (
						<NavLink to={brandRoute("/pickup-and-drop")} className="col footer-links px-2 py-1">
							<span className={this.state.pickup_drop ? "ri-takeaway-fill footer-active-links footer-icon" : "ri-takeaway-line footer-icon"}></span> <br />
							<span className={this.state.pickup_drop ? "active-footer-tab" : ""}>
								{this.state.pickup_drop
									? localStorage.getItem("footerPickupDrop")
									: localStorage.getItem("footerPickupDrop")}
							</span>
						</NavLink>
						):(
						<NavLink to={brandRoute("/explore")} className="col footer-links px-2 py-1">
							<i className={this.state.active_explore ? "icon-SearchFilled-v3 footer-active-links footer-icon" : "icon-SearchInverse-v3 footer-icon"} /> <br />
							<span className={this.state.active_explore ? "active-footer-tab" : ""}>
								{this.state.active_explore
									? localStorage.getItem("footerExplore")
									: localStorage.getItem("footerExplore")}
							</span>
						</NavLink>
						)} */}
						<NavLink to={brandRoute("/cart")} className="col footer-links px-2 py-1">
							<i className={this.state.active_cart ? "ri-shopping-bag-2-fill footer-icon footer-active-links" : "ri-shopping-bag-2-line footer-icon"} /> <br />
							<span className={this.state.active_cart ? "active-footer-tab" : ""}>
								{this.state.active_cart
									? localStorage.getItem("footerCart")
									: localStorage.getItem("footerCart")}
								{cartTotal.productQuantity > 0 && (
								<span
									className="cart-quantity-badge"
									style={{ backgroundColor: "#000000" }}
								>
									{cartTotal.productQuantity}
								</span>
								)}
							</span>
						</NavLink>
						<NavLink to={brandRoute("/my-account")} className="col footer-links px-2 py-1">
							<i className={this.state.active_account ? "ri-user-fill footer-active-links footer-icon" : "ri-user-line footer-icon"} /> <br />
							<span className={this.state.active_account ? "active-footer-tab" : ""}>
								{this.state.active_account
									? localStorage.getItem("footerAccount")
									: localStorage.getItem("footerAccount")}
							</span>
						</NavLink>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	cartTotal: state.total.data,
	alertUnreadTotal: state.alert.alertUnreadTotal,
	user: state.user.user,
});

export default connect(
	mapStateToProps,
	{}
)(Footer);
